import { reloadOnceForStaleRelease } from '@components/RouteErrorPage';
import { isLazyRouteImportPending } from './lazyWithRetry';

/**
 * `vite:preloadError` handler. After a deploy, an open tab can fail to load
 * a chunk of the previous build; one reload picks up the new release.
 *
 * ZLAYT-1485: this must NOT call `event.preventDefault()`. Vite's preload
 * wrapper only rethrows the import error when the event was not prevented;
 * swallowing it made the import resolve to `undefined`, and React.lazy then
 * crashed with "Cannot read properties of undefined (reading 'default')".
 * Now the real error propagates: a lazy route import rejects into
 * lazyWithRetry, which retries once and reloads once. Any other dynamic
 * import (e.g. a modal's `await import(...)`) gets the rejection and this
 * handler reloads once, through the same guard, so there is no alert() and
 * no reload loop.
 */
export default function handlePreloadError(event: Event) {
  const payload = (event as Event & { payload?: unknown }).payload;
  if (isLazyRouteImportPending()) {
    console.warn(
      '[vite:preloadError] a route chunk failed to load; retrying, then reloading once',
      payload
    );
    return;
  }
  console.warn(
    '[vite:preloadError] a chunk failed to load, likely a new release; reloading once',
    payload
  );
  reloadOnceForStaleRelease();
}
